import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    sidebar: localStorage.getItem("sidebard") ? JSON.parse(localStorage.getItem("sidebar")) : true
}

const sidebarSlice = createSlice({
    name: "sidebarSlice",
    initialState,
    reducers: {
        setSidebar: (state, action) => {
            state.sidebar = action.payload;
            localStorage.setItem("sidebar",JSON.stringify(state));
            return state;
        },
    }
});

export const { setSidebar } = sidebarSlice.actions;
export default sidebarSlice;